import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Typography from "../Typography/Typography";
import { useNavigate } from "react-router-dom";

export default function HeroSection({ heading, image, description, link }) {
   const navigate = useNavigate();
   return (
      <div className="bg-black banner-main animation fadeIn verticleline pb-80 pb-xxl-60" style={{ paddingTop: "calc(80px + 80px)" }}>
         <Container>
            <Row className="g-5 align-items-center">
               <Col xs={12} sm={12} md={12} lg={6} xl={7} xxl={7}>
                  <span className="font-60 font42 font-sm-40 line-height-72 line-height-sm-40 font-syne text-white  font-weight-500">{heading}</span>
                  <span className="d-block text-white font-18 font-sm-13 font-syne font-weight-600 mt-3" style={{ width: "90%" }}>
                     {description}
                  </span>
                  {link && (
                     <span className="pointer d-block text-white font-18 font-syne font-weight-600 mt-3" onClick={() => navigate("/get-in-touch")} style={{ textDecoration: "underline" }}>
                        Let's Talk
                     </span>
                  )}
               </Col>
               <Col xs={12} sm={12} md={12} lg={6} xl={5} xxl={5}>
                  <img src={image} alt="blogsBanner" className="img-fluid mx-auto d-block" />
               </Col>
            </Row>
         </Container>
      </div>
   );
}
